module.exports = "pegasus/assets/active-row-border-left.png";